import TargetIcon from "@/assets/icons/target.svg";
import SmartLabel from "@/domain/enums/SmartLabel";
import { cn } from "@/lib/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import SmartLabelIcon from "../SmartLabelIcon";

const smartLabelActiveClassName = {
    [SmartLabel.Focus]: "bg-TypeMail-FocusLight",
    [SmartLabel.PourInfo]: "bg-TypeMail-InformationLight",
    [SmartLabel.Newsletter]: "bg-TypeMail-NewsletterLight",
    [SmartLabel.Suspect]: "bg-TypeMail-SuspectLight",
    [SmartLabel.Autre]: "bg-TypeMail-OtherLight",
    [SmartLabel.Traites]: "bg-TypeMail-TraitesLight",
};

const smartLabelHoverClassName = {
    [SmartLabel.Focus]: "hover:bg-TypeMail-FocusLight",
    [SmartLabel.PourInfo]: "hover:bg-TypeMail-InformationLight",
    [SmartLabel.Newsletter]: "hover:bg-TypeMail-NewsletterLight",
    [SmartLabel.Suspect]: "hover:bg-TypeMail-SuspectLight",
    [SmartLabel.Autre]: "hover:bg-TypeMail-OtherLight",
    [SmartLabel.Traites]: "hover:bg-TypeMail-TraitesLight",
};

type MenuItemProps = {
    label: string | React.ReactNode;
    count?: number;
    id: SmartLabel;
    to: string;
};

const MenuItem = ({ label, count, id, to }: MenuItemProps) => {
    const { t } = useTranslation();

    return (
        <NavLink
            className={({ isActive }) =>
                cn(
                    "flex w-full items-center justify-between gap-2 rounded-md px-1.5 py-2 text-xs",
                    smartLabelHoverClassName[id],
                    isActive && smartLabelActiveClassName[id],
                )
            }
            to={to}
        >
            <div className="flex items-center gap-1 text-left">
                <SmartLabelIcon smartLabel={id} />
                <span className="mb-[-2px]">
                    {t(`navbar.smartLabels.navigation.${label}`)}
                </span>
                {id === SmartLabel.Focus && (
                    <img alt="Focus" className="h-3.5 w-3.5" src={TargetIcon} />
                )}
            </div>
            <span className="text-text-main-title text-[9px]">
                {count || 0}
            </span>
        </NavLink>
    );
};

export default MenuItem;
